<template>
  <Modal title="Configurar adquirentes" :active="active" @close="closeModal()">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <div
        v-for="acquirer in acquirers"
        :key="acquirer.value"
        class="vx-row mb-base"
      >
        <div class="vx-col w-full">
          <h5 class="mb-3">{{ acquirer.label }}</h5>
        </div>
        <div class="vx-col w-full sm:w-1/2 mb-3">
          <span class="label-text">Gateway ID</span>
          <ValidationProvider
            :name="'Gateway ID ' + acquirer.label"
            rules="required|numeric"
            immediate
            v-slot="{ errors }"
          >
            <vs-input
              class="w-full"
              v-model="form[acquirer.value].gatewayId"
              :danger="!!errors.length"
              :disabled="disabled"
              :data-testId="'acquirer_gateway_id_' + acquirer.value"
            />
            <span v-show="!!errors.length" class="text-danger">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>
        <div class="vx-col w-full sm:w-1/2 mb-2">
          <span class="label-text">Antecipação</span>
          <div>
            <vs-switch
              color="success"
              v-model="form[acquirer.value].advanceEnabled"
              style="width: 60px"
              :disabled="disabled"
              :data-testId="'acquirer_advance_enabled_' + acquirer.value"
            >
              <span slot="on">Ativo</span>
              <span slot="off">Inativo</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-col w-full mb-3">
          <span class="label-text">Sistemas de emissão</span>
          <v-select
            class="w-full"
            multiple
            :closeOnSelect="false"
            :options="emissionSystemOptions"
            :reduce="(option) => option.id"
            label="label"
            v-model="form[acquirer.value].emissionSystems"
            placeholder="Selecione os sistemas de emissão"
            @input="onSystemsChange(acquirer.value)"
            :disabled="disabled"
            :data-testId="'acquirer_emission_systems_' + acquirer.value"
          ></v-select>
        </div>
      </div>

      <div class="vx-row" v-if="!disabled">
        <div class="vx-col w-full">
          <span v-show="!allSystemsAssigned" class="text-danger">
            Todos os sistemas de emissão devem ser distribuídos entre as
            adquirentes.
          </span>
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mt-5"
            data-testId="acquirer_config_cancel"
            @click="closeModal()"
            >Cancelar</vs-button
          >
          <vs-button
            color="primary"
            type="gradient"
            class="mt-5"
            data-testId="acquirer_config_save"
            :disabled="invalid || !allSystemsAssigned"
            @click="save()"
            >Salvar</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal.vue';
import vSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { EMISSION_SYSTEMS } from '../../utils/constants';
import creditCardAcquirerApi from '../../services/credit.card.acquirer.api';
import notify from '@/utils/notify';

export default {
  name: 'AcquirerConfigModal',
  components: {
    Modal,
    'v-select': vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    paymentTypeId: {
      type: [Number, String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      acquirers: [],
      emissionSystemOptions: Object.values(EMISSION_SYSTEMS).map((system) => ({
        id: system.key,
        label: system.label,
      })),
      form: {},
    };
  },
  computed: {
    allSystemsAssigned() {
      let total = 0;
      Object.keys(this.form).forEach((key) => {
        total += this.form[key].emissionSystems.length;
      });
      return total === this.emissionSystemOptions.length;
    },
  },
  methods: {
    open() {
      if (this.paymentTypeId == null) return;
      this.$vs.loading();
      creditCardAcquirerApi
        .getAcquirers(this.paymentTypeId)
        .then((data) => {
          let list = Array.isArray(data) ? data : [];
          let acquirers = [];
          let form = {};
          list.forEach((acquirer) => {
            if (!acquirer || !acquirer.name) return;
            acquirers.push({ value: acquirer.name, label: acquirer.name });
            form[acquirer.name] = {
              id: acquirer.id,
              gatewayId:
                acquirer.gatewayId != null ? String(acquirer.gatewayId) : '',
              emissionSystems: Array.isArray(acquirer.emissionSystems)
                ? acquirer.emissionSystems.slice()
                : [],
              advanceEnabled: acquirer.advanceEnabled === true,
            };
          });
          this.acquirers = acquirers;
          this.form = form;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify.notifyFail(this.$vs, error);
        });
    },
    onSystemsChange(acquirerValue) {
      const selected = this.form[acquirerValue].emissionSystems;
      Object.keys(this.form).forEach((key) => {
        if (key === acquirerValue) return;
        this.form[key].emissionSystems = this.form[key].emissionSystems.filter(
          (system) => selected.indexOf(system) === -1,
        );
      });
    },
    closeModal() {
      this.$emit('close');
    },
    save() {
      const acquirers = Object.keys(this.form).map((name) => ({
        id: this.form[name].id,
        name,
        advanceEnabled: this.form[name].advanceEnabled,
        gatewayId: Number(this.form[name].gatewayId),
        emissionSystems: this.form[name].emissionSystems,
      }));
      this.$emit('save', acquirers);
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.open();
        }
      },
    },
  },
};
</script>

<style scoped>
.label-text {
  font-size: 12px;
  font-weight: 200;
  color: #333;
}
</style>
